import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../plugins/store/index.js'

import Home from '@/components/pages/Home.vue'
import Dashboard from '@/components/pages/Dashboard.vue'
import RouteManagement from '@/components/pages/RouteManagement.vue'
import StationManagement from '@/components/pages/StationManagement.vue'
import System from '@/components/pages/System.vue'
import Report from '@/components/pages/Report.vue'
import ReportSummary from '@/components/pages/ReportSummary.vue'
import DataManagement from '@/components/pages/DataManagement.vue'

import Mypage from '@/components/pages/Mypage.vue'

import Signin from '@/components/pages/Signin.vue'
import DeveloperSettingsContainer from '@/pages/developerSettings/containers/DeveloperSettingsContainer.vue'
import SystemSettingsContainer from '@/pages/SystemSettings/containers/SystemSettingsContainer.vue'
import MunicipalOrganizationContainer from '@/pages/SystemSettings/containers/MunicipalOrganizationContainer.vue'

import { Hub } from "@aws-amplify/core"
import { Auth } from "aws-amplify"
let user;

// ユーザー管理
getUser().then((user) => {
  if (user) {
    router.push({path: '/'});
  }
});

function getUser() {
  return Auth.currentAuthenticatedUser().then((data) => {
    if (data) {
      store.commit('setUser', data);
      return data;
    }else{
      Auth.signOut()
    }
  }).catch(() => {
    store.commit('setUser', null);
    return null;
  });
}

// ログイン状態管理
Hub.listen("auth", async (data) => {
  console.log("Hub.listen")
  if (data.payload.event === 'signOut'){
    user = null;
    store.commit('setUser', null);
    router.push({path: '/signin'});
  } else if (data.payload.event === 'signIn') {
    user = await getUser();
    router.push({path: '/'});
  }
});

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true}
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true}
    },
    {
      path: '/routemanagement',
      name: 'RouteManagement',
      component: RouteManagement,
      meta: { requiresAuth: true}
    },
    {
      path: '/stationmanagement',
      name: 'StationManagement',
      component: StationManagement,
      meta: { requiresAuth: true}
    },
    {
      path: '/system-settings/:page?',
      name: 'SystemSettings',
      component: SystemSettingsContainer,
      meta: { requiresAuth: true}
    },
    {
      path: '/report',
      name: 'Report',
      component: Report,
      meta: { requiresAuth: true}
    },
    {
      path: '/report/summary',
      name: 'ReportSummary',
      component: ReportSummary,
      meta: { requiresAuth: true }
    },
    {
      path: '/datamanagement',
      name: 'DataManagement',
      component: DataManagement,
      meta: { requiresAuth: true}
    },
    {
      path: '/mypage',
      name: 'Mypage',
      component: Mypage,
      meta: { requiresAuth: true}
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/developersettings',
      name: 'Developersettings',
      component: DeveloperSettingsContainer,
      meta: { requiresAuth: true}
    },
  ]
})

// リダイレクト設定
router.beforeResolve(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        user = await getUser();
        if (!user) {
            return next({
                path: '/signin',
                query: { redirect: to.fullPath }
            });
        }
        return next()
    }
    return next()
});

export default router

